<script lang="ts" setup>
/**
 * トークルーム一覧。
 */

import { defineProps } from "vue";
import TalkRoomMaster from "@/components/communityTalk/talkRoom/TalkRoomMaster.vue";
import { LayoutTagGetResponse_WordSetting } from "@/apiRequests/models/communityTalk/layoutTagGetResponse";
import { TalkRoomDto } from "@/apiRequests/models/communityTalk/talkRoomGetResponse";

interface Props {
	/**
	 * トークルーム情報群。
	 */
	talkRooms: TalkRoomDto[];
	/**
	 * 表示タグ設定>文言設定。
	 */
	wordSettings: LayoutTagGetResponse_WordSetting;
	/**
	 * CommunityTalkStoreのInject用キー。
	 */
	communityTalkStoreKey: string;
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars, no-undef
const props = defineProps<Props>();
</script>

<template>
	<main class="revico-community-talk-talkroom">
		<h1 class="revico-community-talk-talkroom--title">トークルーム一覧</h1>
		<ul class="revico-community-talk-talkroom-list">
			<li v-for="(talkRoom, index) in talkRooms" :key="index" class="revico-community-talk-talkroom-list-item" :data-display-talkroom-id="talkRoom.displayTalkRoomId">
				<TalkRoomMaster :talkRoom="talkRoom" :wordSettings="wordSettings" :communityTalkStoreKey="communityTalkStoreKey" />
			</li>
		</ul>
	</main>
</template>

<style lang="scss">
.revico-widget .revico-community-talk {
	&-talkroom {
		width: 100%;

		&--title {
			display: none;
		}
		&-list {
			&-item {
				margin-bottom: 32px;
				padding: 20px;
				background-color: var(--talkroom-bg-color);

				&:last-child {
					margin-bottom: 0;
				}
			}
		}
	}
}
</style>
